module.exports = __webpack_public_path__ + "static/media/ic_menu_white_24px.c800523f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_menu_white_24px.svg
// module id = 298
// module chunks = 3